import { render, staticRenderFns } from "./OcardRules.vue?vue&type=template&id=ad76d256&"
import script from "./OcardRules.vue?vue&type=script&lang=js&"
export * from "./OcardRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports